import { AppointmentPaymentMethod } from '@/types/enums/payment-methods.enum';

export const currencyFormatter = (value: number, symbol = true) => {
  value = Number(value);

  if (!value) {
    value = 0;
  }

  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  let formatted = formatter.format(Math.abs(value));

  if (value < 0) {
    formatted = formatted.replace(/^R\$\s/, 'R$ -');
  }

  if (!symbol) {
    return formatted.replace('R$', '').trim();
  }

  return formatted;
};

export const getPaymentMethodName = (method: AppointmentPaymentMethod) => {
  const paymentMethodOptions: Record<AppointmentPaymentMethod, string> = {
    [AppointmentPaymentMethod.CREDIT_CARD]: 'Cartão de crédito',
    [AppointmentPaymentMethod.PIX]: 'Pix',
  };

  return paymentMethodOptions[method];
};
